export default function (state=null, action)  {
    switch(action.type){
      case "CUESTIONARIO_SELECCIONADO":
        return action.payload;
      default:
        break;
    }
    return state;
}